import { useState, useEffect, useRef, useMemo } from 'react';
import {
    Container,
    Content,
    ContactsCard,
} from './styled';
import {
    Avatar,
    Search,
    Skeleton
} from '..';
import { getFullClients } from '../../service/serviceChat/clientsService';

export function Contacts({onChange}) {
    const [contacts, setContacts] = useState([]);
    const [textSearch, setTextSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [displayedPeople, setDisplayedPeople] = useState(50);
    const listRef = useRef(null);

    const searchContacts = async () => {
        setLoading(true);
        setContacts(await getFullClients());
        setLoading(false);
    };
    useEffect(() => {
        searchContacts();
    }, []);

    const onFilterContacts = (item) => {
        const textSearchLower = textSearch.toLowerCase();
        if (textSearch.length < 3) return item
        return item.name.toLowerCase().includes(textSearchLower)
            || item.number_client.toLowerCase().includes(textSearchLower);
    };
    const handleScroll = () => {
        const element = listRef.current;
        if (element.scrollTop + element.clientHeight + 50 >= element.scrollHeight) {
            setDisplayedPeople(prevCount => prevCount + 50);
        }
    };
    useEffect(() => {
        const element = listRef.current;
        element.addEventListener('scroll', handleScroll);
        return () => element?.removeEventListener('scroll', handleScroll);
    }, []);
    const visibleData = contacts?.filter(onFilterContacts).slice(0, displayedPeople);
    const myStateElements = useMemo(() => {
        return visibleData?.map((item) => {
            return (
                <li className='card--Contact'
                    key={item.id}
                    onClick={() =>
                        onChange(item)
                    }
                >
                    <span className='avatar--'>
                        <Avatar
                            name={item?.name}
                            width={'3.5rem'}
                            height={'3.5rem'}
                            fontSize={'1.5rem'}
                        />
                    </span>
                    <span className='info--'>
                        <span className='name'>
                            <span className='name--overflow'>
                                {item.name}
                            </span>
                        </span>
                        <span className='description'>
                            {item?.number_client}
                        </span>
                    </span>
                </li>
            );
        })
    }, [visibleData]);
    const SkeletonRender = ({ count }) => {
        const skeletonArray = [];
        for (let i = 0; i < count; i++) {
            skeletonArray.push(<Skeleton type='contact' key={i} />);
        }
        return (
            <div>
                {skeletonArray}
            </div>
        );
    };

    return (
        <Container>
            <Content>
                <Search
                    className='search'
                    value={textSearch}
                    onChange={
                        (e) => setTextSearch(e.target.value)
                    }
                />
                <ContactsCard ref={listRef}>
                    {loading
                        ? <SkeletonRender count={15} />
                        : <>{myStateElements}</>
                    }
                </ContactsCard>
            </Content>
        </Container >
    );
}